{
	"placeholder": {
		"title": "Coming soon"
	},
	"dashboard": {
		"greeting": "Good day, {{name}}",
		"signedInAs": "You are signed in as <strong>{{role}}</strong>.",
		"signedInAsCanSwitch": "You are signed in as <strong>{{role}}</strong>. Switch roles from the account menu in the sidebar.",
		"statPeople": "People registered",
		"statAwaitingApproval": "Cards awaiting approval",
		"statPrintBatches": "In print batches",
		"statReadyCollection": "Ready for collection",
		"wiredTitle": "What's wired so far",
		"wiredBody": "Authentication is live end to end: sign-in, per-role two-factor, forced password change, role switching and sign-out. The database has people, AC cards, the printing pipeline and the audit trail, but no HTTP routes yet — the screens above come online as those land.",
		"mfaLabel": "Signed in with 2FA:",
		"yes": "yes",
		"no": "no"
	},
	"accommodation": {
		"message": "Room allocation is coming soon. For accommodation questions, contact an administrator meanwhile."
	},
	"accreditationRecords": {
		"title": "View Records",
		"summary": "Every accredited person and their AC card status, searchable and filterable."
	},
	"accreditationAdd": {
		"title": "Add Record",
		"summary": "Register a new person for accreditation."
	},
	"incidentHelpdesk": {
		"message": "The incident helpdesk is coming soon. To report a problem, contact an administrator meanwhile."
	},
	"inventory": {
		"message": "Inventory is coming soon. For stock questions, contact an administrator meanwhile."
	},
	"wslInventory": {
		"message": "WSL inventory is coming soon. For equipment on loan, contact an administrator meanwhile."
	},
	"profile": {
		"message": "Your profile page is coming soon. To change your details, ask an administrator meanwhile."
	},
	"reports": {
		"message": "Reports are coming soon. View Records can export its list to CSV meanwhile."
	},
	"volunteers": {
		"message": "The volunteer dashboard is coming soon. For volunteer questions, contact an administrator meanwhile."
	},
	"volunteerRecords": {
		"message": "Volunteer records are coming soon. Volunteers registered for accreditation appear in View Records meanwhile."
	},
	"acCardZones": {
		"title": "AC Card Zones",
		"summary": "Default zone access per function and card category."
	},
	"affiliatedOrganizations": {
		"title": "Affiliated Organizations",
		"summary": "Delegations, federations and partners people are accredited under."
	},
	"functions": {
		"title": "Main / Sub Functions",
		"summary": "The function taxonomy printed on every AC card."
	},
	"responsibleOrganizations": {
		"title": "Responsible Organizations",
		"summary": "Bodies accountable for a group of people."
	},
	"sports": {
		"title": "Sports",
		"summary": "Sports and disciplines on the programme."
	},
	"subAgencies": {
		"title": "Sub Agencies",
		"summary": "Agencies under a responsible organization."
	},
	"arrivalDeparture": {
		"message": "Arrival and departure tracking is coming soon. For travel details, contact an administrator meanwhile."
	},
	"transportation": {
		"message": "Transport bookings are coming soon. For vehicle requests, contact an administrator meanwhile."
	}
}
